import React from "react";
import { useLanguage } from "@/i18n/LanguageProvider";
import { Zap } from "lucide-react";

const APP_SCREEN = "/assets/brand/app_home_screen.png";

export default function PhoneMockup() {
  const { lang } = useLanguage();
  // Localize the small floating notification bubble for AR polish
  const bubble = lang === "ar"
    ? { amount: "+١٢ ر.ع.", label: "تأكيد الاستلام" }
    : { amount: "+12 OMR", label: "Pickup confirmed" };

  return (
    <div className="relative" data-testid="hero-phone-mockup">
      {/* Soft red+navy glow halo behind the device */}
      <div
        className="absolute -inset-8 rounded-[3rem] pointer-events-none"
        aria-hidden="true"
        style={{
          background:
            "radial-gradient(40% 50% at 30% 30%, rgba(152,27,55,0.35), transparent 60%), radial-gradient(50% 60% at 70% 70%, rgba(46,46,46,0.6), transparent 65%)",
          filter: "blur(40px)",
        }}
      />

      {/* Floating phone */}
      <div
        className="relative mx-auto w-[300px] h-[610px] rounded-[3rem] bg-[#0a0a0a] p-3 shadow-[0_40px_80px_-20px_rgba(0,0,0,0.6),0_0_0_2px_rgba(255,255,255,0.06)] animate-float-slow"
        style={{ transform: "rotate(-3deg)" }}
      >
        {/* Notch */}
        <div className="absolute top-3 left-1/2 -translate-x-1/2 w-32 h-7 bg-black rounded-b-[1.25rem] z-30" aria-hidden="true" />
        {/* Side button hint */}
        <div className="absolute -end-[3px] top-32 w-[3px] h-16 bg-[#1a1a1a] rounded-r" aria-hidden="true" />

        {/* Screen — now displays the real Twasal Awasal app home screen */}
        <div className="relative w-full h-full rounded-[2.4rem] bg-white overflow-hidden">
          <img
            src={APP_SCREEN}
            alt="Twasal Awasal app home screen"
            className="absolute inset-0 w-full h-full object-cover object-top"
            draggable="false"
          />
        </div>
      </div>

      {/* Floating notification bubble (kept exactly as before) */}
      <div
        className="hidden md:flex absolute -top-4 -start-10 items-center gap-2 px-3 py-2 rounded-2xl bg-white shadow-[0_12px_30px_-10px_rgba(152,27,55,0.4)] animate-float-slow"
        style={{ animationDelay: "1.2s" }}
        aria-hidden="true"
      >
        <span className="w-7 h-7 rounded-full bg-delfi-red/10 text-delfi-red flex items-center justify-center">
          <Zap size={14} />
        </span>
        <div>
          <p className="text-[10px] font-bold text-delfi-navy leading-none">{bubble.amount}</p>
          <p className="text-[8px] text-delfi-navy/55 mt-0.5">{bubble.label}</p>
        </div>
      </div>
    </div>
  );
}
